import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, Output, OnInit, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription, debounceTime, map, startWith } from 'rxjs';
import { companiaLista } from 'src/app/interface/CompaniaListaInterface';
import { SseService } from 'src/app/services/SseService';
import { TemaService } from 'src/app/services/tema.services';
import { ToastrService } from 'ngx-toastr';
import { OAuthService } from '../../services/oauth.service';
import { PlanificadorService } from '../models/control.service';
import { SelectModel } from '../models/models.component';
import { MatTableDataSource } from '@angular/material/table';
import { elementMatches } from '@fullcalendar/core/internal';
import { SelectionModel } from '@angular/cdk/collections';
import { global } from 'src/app/global';
// MatSnackBar removed; using ToastrService instead
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MetaApiService } from 'src/app/services/meta-api.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { el } from '@fullcalendar/core/internal-common';

// Agregar interface para las condiciones
export interface Condicion {
  idindicador: number;
  indicador: string;
  detalle: string;
  jsonData: string;
  verificado: boolean;
  verificadoauto: boolean;
  ratio: boolean;
  explosionprecio: boolean;
}

interface Variacion {
  fechaVariacion: string;
  variacion: number;
}

interface VariacionData {
  iso: string;
  idnectum: number;
  variacions: Variacion[];
}

interface AdminUser {
  userId: number;
  email: string;
  userTypeId: number;
  creationDate: string;
  validDays: number;
  duration: number;
  lastLoginDate: string | null;
  lastActivity: string | null;
  carteras: number;
}

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminComponent implements OnInit, OnDestroy {
      public mentionConfig = {}
  
  currencySymbol: string = '';
  public isAnalisis: boolean = true;
  public companias: any;
  public companias2: any;
  myControl = new FormControl('');
  options: any;
  public queryParams: string;
  filteredOptions: Observable<any[]>;
  public selectedIso: any;
  public companiaselected: any;
  public selectedTab: number = 0;
  public data1: any;
  public token: any;
  public mercado: any;
  public mercadonombre: string = '';
  public selectedValue: string;
  public selectedValue2: string;
  public keymetricsttm: any;
  public ratiosttm: any;
  public quoteshort: any;
  public invertirEstilos: boolean = true;
  public SubTema: Subscription;
  marketInput: string = '';
  public latestDate: string = '';
  contractSymbol: string = '';
  allIndicatorTypes: any;
  indicatorsNumbers: string[] = [];
  esEdicion: boolean = false; // <-- Add this line
  condicionActual: Condicion | null = null; // <-- Add this line
  formCondicion!: FormGroup; // <-- Add this line

  indicatorTypes: SelectModel[] = [];

  public indicatorsNew: string[] = [];
  public indicatorsFundamentales: string[] = [];
  public indicatorsIa: string[] = [];
  public condicionesIa: string[] = [];

  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['select', 'counter', 'iso', 'idnectum', 'variaciones', 'actions'];
  dataSource = new MatTableDataSource<VariacionData>();
  private eventSource: EventSource | null = null;
  isLoading = false;
  displayedColumnsUsuarios: string[] = ['userId', 'email', 'userTypeId', 'creationDate', 'lastLoginDate', 'lastActivity', 'carteras', 'validDays', 'duration', 'actions'];
  dataSourceUsuarios = new MatTableDataSource<AdminUser>([]);
  isLoadingUsuarios = false;

  // Actualizar propiedades para condiciones
  //dataSourceCondiciones = new MatTableDataSource<Condicion>([]);
  dataSourceCondicionesFiltrado = new MatTableDataSource<Condicion>([]);
  displayedColumnsCondiciones: string[] = [
     'indicador', 'detalle',  
    'verificado', 'verificadoAuto', 'ratio', 'explosionPrecio', 'actions'
  ];
  isLoadingCondiciones: boolean = false;

  // MetaAPI specification download (single)
  metaapiSymbol: string = '';
  metaapiAccountId: string = '';
  specTipoBroker: string = 'METAAPI';
  specLoading: boolean = false;
  specResult: any = null;

  // MetaAPI specification download (por lista)
  specListMercado: string = '';
  specListLoading: boolean = false;
  specListProgress: number = 0;
  specListTotal: number = 0;
  specListErrors: string[] = [];

  @ViewChild('dialogoCondicion') dialogoCondicion!: TemplateRef<any>;
  @ViewChild(CdkVirtualScrollViewport) viewport!: CdkVirtualScrollViewport;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private _sseservice: SseService,
    private toastr: ToastrService,
    private _cookieService: CookieService,
    private _httclient: HttpClient,
    public temaservicio: TemaService,
    private oauthService: OAuthService,
    private http: HttpClient,
    public planificadorsv: PlanificadorService,
    // snackBar removed; using toastr
    private dialog: MatDialog,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private metaApiService: MetaApiService,
    private route: ActivatedRoute
  ) { 
    this.initFormCondicion();
  }

  ngOnInit() {
    const currentPath = this.route.snapshot.routeConfig?.path;
    if (currentPath === 'admin-usuarios') {
      this.selectedTab = 3;
      this.cargarUsuarios();
    }

    // Auto-populate MetaAPI account ID from stored credentials
    const savedAccountId = localStorage.getItem('metaapi_account_id');
    if (savedAccountId) this.metaapiAccountId = savedAccountId;

    this.planificadorsv.loadIndicatorTypes()
      .then((res: any) => {
        this.allIndicatorTypes = res.data;
        this.indicatorsNumbers = this.allIndicatorTypes.indicadoresTecnicosIA;
        this.indicatorsNew = this.allIndicatorTypes.indicadoresTecnicosIA;
        this.indicatorsFundamentales = this.allIndicatorTypes.indicadoresFundamentalesIA;
        this.indicatorsIa = this.allIndicatorTypes.indicadoresIA;
        this.condicionesIa = this.allIndicatorTypes.condicionesIa;
        this.planificadorsv.indicatorsIaSinEspacios = this.indicatorsIa.map(el => el.replace(' ', '_'));
        let datos: string[] = this.planificadorsv.indicatorsIaSinEspacios;
        datos.push(...this.condicionesIa);
        this.mentionConfig = {
                    mentions: [
                        {
                            items: this.planificadorsv.indicatorsIaSinEspacios,
                            triggerChar: '#', allowSpace: true
                        }
                    ], returnTrigger: true
                };
        let { tiporatios, periodos } = res.data;
        //  this.frecuencia.emit(periodos)
        tiporatios.forEach((el: any, index: number) => {
          this.indicatorTypes.push({ description: el, value: index + '' })
        });
      });
    console.log("deberia ejecutarse AAPL");
    this.selectedIso = 'AAPL';
    this.cargarData('AAPL');
    this.token = this._cookieService.get('auth_token');
    this._sseservice.apiPostNew("listamercados", {}, this.token).subscribe({
      next: (data: any) => {
        console.log(data);
        this.mercado = data;
      }
    });
    this._sseservice.apiGetNew('getLatestHistoricoDate').subscribe({
      next: (data: any) => {
        console.log(data.latestDate);
        this.marketInput = data.latestDate;
        this.latestDate = data.latestDate;
      }
    })
    this.SubTema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.invertirEstilos = data;
      }
    });
    // Inicializar el DataSource
    this.dataSourceCondicionesFiltrado = new MatTableDataSource<any>([]);
    

  }

  buscarCompania() {
    const jsonData = {
      idmercado: this.selectedValue
    };
    this._sseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
      next: (data: any) => {
        this.companias = data;
        console.log("data: ", data);
        /*         this.options = data.map((compania: any) => {
                  return {
                    descripcion: compania.descripcion,
                    iso: compania.iso
                  };
                }); */
        this.options = data;
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          debounceTime(200),
          map(value => this._filter(value || '')),
        );

      }
    });
  }
  syncCompaniaLista() {
    this._sseservice.apiGetNew('syncCompaniaLista').subscribe({
      next: (response) => {
        this.toastr.success('Sincronización exitosa', 'Éxito', { timeOut: 5000 });
        console.log('Sincronización completada:', response);
      },
      error: (error) => {
        this.toastr.success('Error en la sincronización', 'Exito', { timeOut: 5000 });
        console.error('Error en la sincronización:', error);
      }
    });
  }
  syncCompania() {
    this._sseservice.apiGetNew('syncCompania').subscribe({
      next: (response) => {
        this.toastr.success('Sincronización exitosa', 'Éxito', { timeOut: 5000 });
        console.log('Sincronización completada:', response);
      },
      error: (error) => {
        this.toastr.success('Error en la sincronización', 'Exito', { timeOut: 5000 });
        console.error('Error en la sincronización:', error);
      }
    });
  }
  buscarCompania2() {
    const jsonData = {
      idmercado: this.selectedValue2
    };
    this._sseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
      next: (data: any) => {
        this.companias2 = data;
        console.log("data: ", data);
        /*         this.options = data.map((compania: any) => {
                  return {
                    descripcion: compania.descripcion,
                    iso: compania.iso
                  };
                }); */
        this.options = data;
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          debounceTime(200),
          map(value => this._filter(value || '')),
        );

      }
    });
  }
  descargarDatos(idmercado: string): void {
    if (idmercado) {
      this._sseservice.apiGetNew(`descargarDatos?idmercado=${idmercado}&idnectum=0`).subscribe({
        //agregar toastr para notificar que se termino la descarga
        next: (response) => {
          this.toastr.success('Descarga completada exitosamente', 'Éxito', { timeOut: 5000 });
          // Handle the response data if needed
          console.log('Datos descargados:', response);
        },
        error: (error) => {
          this.toastr.error('Error al descargar los datos', 'Error', { timeOut: 5000 });
          console.error('Error al descargar datos:', error);
        }
      });
    }
  }

  descargarCondicionesJson() {
    this._sseservice.apiGetNew('listarCondicionJsons').subscribe({
      next: (response) => {
        this.toastr.success('Descarga completada exitosamente', 'Éxito', { timeOut: 5000 });
        // Handle the response data if needed
        //console.log('Condiciones descargadas:', response);

        // Procesar las condiciones con un retraso entre cada una
        this.procesarCondicionesConRetraso(response);
      },
      error: (error) => {
        this.toastr.error('Error al descargar las condiciones', 'Error', { timeOut: 5000 });
        console.error('Error al descargar condiciones:', error);
      }
    });
  }

  verificarCondicionesJson() {
    this._sseservice.apiGetNew('ia/verificarCondicionJsons').subscribe({
      next: (response) => {
        this.toastr.success('Descarga completada exitosamente', 'Éxito', { timeOut: 5000 });
        // Handle the response data if needed
        //console.log('Condiciones descargadas:', response);

        // Procesar las condiciones con un retraso entre cada una
        this.procesarCondicionesConRetraso(response);
      },
      error: (error) => {
        this.toastr.error('Error al descargar las condiciones', 'Error', { timeOut: 5000 });
        console.error('Error al descargar condiciones:', error);
      }
    });
  }

  // Método para procesar condiciones con retraso
  procesarCondicionesConRetraso(condiciones: any[]) {
    // Crear una copia del array para no modificar el original
    const condicionesCopia = [...condiciones];

    // Función recursiva para procesar cada condición con retraso
    const procesarSiguienteCondicion = () => {
      if (condicionesCopia.length === 0) {
        console.log('Todas las condiciones han sido procesadas');
        return;
      }

      const condicion = condicionesCopia.shift(); // Tomar la primera condición
      console.log('Condición descargada:', condicion);

      let condicionorginiarl = condicion.indicador;
      let parts: string[] = [];

      if (condicionorginiarl.includes(' y '))
        condicionorginiarl = condicionorginiarl.replaceAll(' y ', ' and ');
      if (condicionorginiarl.includes(' && '))
        condicionorginiarl = condicionorginiarl.replaceAll(' && ', ' and ');
      if (condicionorginiarl.includes(' & '))
        condicionorginiarl = condicionorginiarl.replaceAll(' & ', ' and ');

      if (condicionorginiarl.includes(' and ')) {
        parts = condicionorginiarl.split(' and ');
      } else {
        parts.push(condicionorginiarl);
      }

      if (condicion.indicador != '') {
        for (let i = 0; i < parts.length; i++) {
          const condicionpart = parts[i];
          let indicaorestemp: string[] = [];
          let condicionreemplazada = this.replaceWithIndicators(condicionpart, indicaorestemp)
          console.log(condicionreemplazada);

          this._sseservice.apiPostNew('conditions/get_conditions', '{"input": "' + condicionreemplazada + '"}', '').toPromise()
            .then(response => {
              if (response.output[0].operador === 'error') {
                this.toastr.error(response.output[0].other_operador);
                this.planificadorsv.loadingModel = false;
              } else {
                console.log(JSON.stringify(response));
                let finalSentence = this.restoreWithOriginalWords(JSON.stringify(response), indicaorestemp);
                let interpretacionData = JSON.parse(finalSentence);
                let condicionuno = interpretacionData.output[0];

                this._sseservice.apiPostNew('actualizarCondicionJson', { json: condicionuno, idindicador: condicion.idindicador }, '').subscribe({
                  next: (data: any) => {
                    console.log(data);

                  }
                });
              }
            }).catch(error => {
              // this.loading = false;
            });
        }
      }

      // Programar el procesamiento de la siguiente condición después de 1 segundo
      setTimeout(procesarSiguienteCondicion, 200);
    };

    // Iniciar el procesamiento de condiciones
    procesarSiguienteCondicion();
  }

  restoreWithOriginalWords(sentence: string, wordsToReplace: string[]): string {
    let words = sentence.split('"');
    words = words.map(word => {
      if (word.startsWith('indicador')) {
        const index = parseInt(word.replace('indicador_', '')) - 1;
        return wordsToReplace[index].replaceAll('_', ' ');
      }
      return word;
    });

    return words.join('"');
  }
  replaceWithIndicators(sentence: string, indicadoresIA: string[]): string {
    let words = sentence.split(' ');
    let indicatorIndex = 1;
    console.log("Estos son los indicadores: ", this.planificadorsv.indicatorsIaSinEspacios.length);
    words = words.map(word => {
      const index = this.planificadorsv.indicatorsIaSinEspacios.indexOf(word);
      if (index !== -1) { indicadoresIA.push(word) }
      return index !== -1 ? `indicador_${indicatorIndex++}` : word;
    });

    return words.join(' ');
  }
  descargarDatosAPI() {
    this._sseservice.apiGetNew('actualizarDatos').subscribe({
      next: (response) => {
        this.toastr.success('Datos descargados con éxito', 'Éxito', { timeOut: 5000 });
      },
      error: (error) => {
        this.toastr.success('Error en la sincronización', 'Exito', { timeOut: 5000 });
      }
    });

  }

  /*   private _filter(value: string): any[] {
      const filterValue = value.toLowerCase();
      return this.options.filter((option: companiaLista) => 
        option.descripcion.toLowerCase().includes(filterValue) || option.iso.toLowerCase().includes(filterValue)
      );
    } */

  private _filter(value: string): any[] {
    console.log("Estos entra en VALUE: ", this.options);
    const filterValue = value.toLowerCase();
    const criteria = filterValue.split(' ');

    // Inicializar filtros para iso y descripcion
    let isoFilter = '';
    let descripcionFilter = '';
    let mercadoFilter = '';
    let tipoFilter = '';
    let volumenFilter: { operator: string, value: number } | null = null;
    let cotizacionFilter: { operator: string, value: number } | null = null;

    // Iterar sobre los criterios y asignar filtros
    criteria.forEach(criterion => {
      if (criterion.startsWith('iso:')) {
        isoFilter = criterion.replace('iso:', '');
      } else if (criterion.startsWith('descripcion:')) {
        descripcionFilter = criterion.replace('descripcion:', '');
      } else if (criterion.startsWith('mercado:')) {
        mercadoFilter = criterion.replace('mercado:', '');
      } else if (criterion.startsWith('tipo:')) {
        tipoFilter = criterion.replace('tipo:', '');
      } else if (criterion.startsWith('volumen>')) {
        const value = parseFloat(criterion.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '>', value: value };
        }
      } else if (criterion.startsWith('volumen<')) {
        const value = parseFloat(criterion.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '<', value: value };
        }
      } else if (criterion.startsWith('cotizacion>')) {
        const value = parseFloat(criterion.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '>', value: value };
        }
      } else if (criterion.startsWith('cotizacion<')) {
        const value = parseFloat(criterion.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '<', value: value };
        }
      }
    });

    return this.options.filter((option: companiaLista) => {
      const matchesIso = isoFilter ? option.iso.toLowerCase().includes(isoFilter) : true;
      const matchesDescripcion = descripcionFilter ? option.descripcion.toLowerCase().includes(descripcionFilter) : true;
      const mercadoMatch = mercadoFilter === '' || (option.mercado && option.mercado.toLowerCase().includes(mercadoFilter));
      const tipoMatch = tipoFilter === '' || (option.tipo && option.tipo.toLowerCase().includes(tipoFilter));
      let volumenMatch = true;
      if (volumenFilter) {
        switch (volumenFilter.operator) {
          case '>':
            volumenMatch = option.volumen > volumenFilter.value;
            break;
          case '<':
            volumenMatch = option.volumen < volumenFilter.value;
            break;
        }
      }
      let cotizacionMatch = true;
      if (cotizacionFilter) {
        switch (cotizacionFilter.operator) {
          case '>':
            cotizacionMatch = option.precioteorico > cotizacionFilter.value;
            break;
          case '<':
            cotizacionMatch = option.precioteorico < cotizacionFilter.value;
            break;
        }
      }

      return matchesIso && matchesDescripcion && mercadoMatch && tipoMatch && volumenMatch && cotizacionMatch;
    });
  }
  cargarUsuarios(): void {
    if (this.isLoadingUsuarios) {
      return;
    }

    this.isLoadingUsuarios = true;
    this._sseservice.apiGetNew('admin/listaUsuarios').subscribe({
      next: (data: AdminUser[]) => {
        this.dataSourceUsuarios.data = Array.isArray(data) ? data : [];
        this.cdRef.markForCheck();
      },
      error: (error: any) => {
        console.error('Error al cargar usuarios:', error);
        this.toastr.error('No fue posible cargar la lista de usuarios', 'Error', { timeOut: 5000 });
        this.dataSourceUsuarios.data = [];
        this.isLoadingUsuarios = false;
        this.cdRef.markForCheck();
      },
      complete: () => {
        this.isLoadingUsuarios = false;
        this.cdRef.markForCheck();
      }
    });
  }

  eliminarUsuario(usuario: AdminUser): void {
    if (this.isLoadingUsuarios) {
      return;
    }

    const confirmar = confirm(`¿Está seguro de eliminar al usuario ${usuario.email}?`);
    if (!confirmar) {
      return;
    }

    this.isLoadingUsuarios = true;
    this._sseservice.apiPostNew('admin/eliminarUsuario', { userId: usuario.userId }, this.token).subscribe({
      next: () => {
        this.toastr.success('Usuario eliminado correctamente', 'Éxito', { timeOut: 5000 });
        this.dataSourceUsuarios.data = this.dataSourceUsuarios.data.filter(u => u.userId !== usuario.userId);
        this.cdRef.markForCheck();
      },
      error: (error: any) => {
        console.error('Error al eliminar usuario:', error);
        // El 403 (usuario no administrador) trae el motivo en error.error.message
        this.toastr.error(error?.error?.message || 'No fue posible eliminar el usuario', 'Error', { timeOut: 5000 });
        this.isLoadingUsuarios = false;
        this.cdRef.markForCheck();
      },
      complete: () => {
        this.isLoadingUsuarios = false;
        this.cdRef.markForCheck();
      }
    });
  }

  ajustarValidDays(usuario: AdminUser, delta: number): void {
    if (this.isLoadingUsuarios || !usuario) {
      return;
    }

    const nuevoValor = Math.max(0, Number(usuario.validDays ?? 0) + delta);
    if (nuevoValor === usuario.validDays) {
      return;
    }

    this.isLoadingUsuarios = true;
    const payload = {
      userId: usuario.userId,
      validDays: nuevoValor
    };

    this._sseservice.apiPostNew('admin/actualizarValidDays', payload, this.token).subscribe({
      next: () => {
        usuario.validDays = nuevoValor;
        const data = this.dataSourceUsuarios.data.map(u =>
          u.userId === usuario.userId ? { ...u, validDays: nuevoValor } : u
        );
        this.dataSourceUsuarios.data = data;
        this.cdRef.markForCheck();
      },
      error: (error: any) => {
        console.error('Error al actualizar días vigentes:', error);
        this.toastr.error(error?.error?.message || 'No fue posible actualizar los días vigentes', 'Error', { timeOut: 5000 });
        this.isLoadingUsuarios = false;
        this.cdRef.markForCheck();
      },
      complete: () => {
        this.isLoadingUsuarios = false;
        this.cdRef.markForCheck();
      }
    });
  }
  async buscarConid() {
    console.log('buscar conid ' + this.companias2.length);
    this.mercadonombre = this.mercado.find((m: any) => m.idmercado == this.selectedValue2)?.iso || '';
    console.log('mercado nombre ' + this.mercadonombre);
    this._sseservice.apiPostNew('listarcompaniaspormercadosinconid', { idmercado: this.selectedValue2 }, this.token).subscribe({
      next: async (data: any) => {
        console.log("data: ", data);
        for (const compania of data) {
          console.log(compania);
          if (compania.iso) {
            await this.procesarCompania(compania, false);
            await this.delay(1000); // Espera 1 segundo antes de la siguiente iteración
          }
        }
      }
    });
    /*
    for (const compania of this.companias2) {
      console.log(compania);
      if (compania.iso) {
        await this.procesarCompania(compania, false);
        await this.delay(1000); // Espera 1 segundo antes de la siguiente iteración
      }
    }*/
  }
  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  private procesarCompania(compania: any, tieneconid: boolean): Promise<void> {
    return new Promise((resolve) => {
      console.log(this.mercadonombre);
      this.oauthService.apiGetIbrk(`/iserver/secdef/search?symbol=${compania.iso}`).subscribe({
        next: (resp => {
          // resp == 
          console.log(`getOptimalWallet resp for ${compania.iso}:`, resp);

          if (!Array.isArray(resp)) {
            console.warn('Respuesta inesperada al buscar conid', resp);
            resolve();
            return;
          }

          const results = resp as any[];

          //if (!tieneconid) {
            const targetSymbol = (compania.symbol ?? compania.iso ?? '').toUpperCase();
            const targetDescription = (compania.descripcion ?? compania.description ?? '').toLowerCase();

            const firstItem = results.find((item: any) => {
              const itemSymbol = (item.symbol ?? '').toUpperCase();
              if (itemSymbol !== targetSymbol || !item.conid) {
                return false;
              }

              if (!targetDescription) {
                return true;
              }

              const itemDescription = (item.description ?? '').toLowerCase();
              return itemDescription === targetDescription;
            }) ?? results.find((item: any) => (item.symbol ?? '').toUpperCase() === targetSymbol && item.conid);

            if (firstItem && firstItem.conid && firstItem.symbol) {
              this._sseservice.apiPost('actualizarConid', true, {
                conid: firstItem.conid,
                iso: firstItem.symbol
              }, 2).then((response) => {
                console.log(`Conid actualizado para ${firstItem.symbol}:`, response);
                resolve();
              });
            } else {
              console.log('No se encontró conid o symbol en la respuesta');
              resolve();
            }
            
          //}

         // if (results.length > 0) {
            const cfdSection = results.find((item: any) =>
                item.sections && item.sections.some((section: any) => section.secType === 'CFD')
              );
              if (cfdSection) {
                const cfdInfo = cfdSection.sections.find((section: any) => section.secType === 'CFD');
                if (cfdInfo && cfdInfo.conid) {
                  console.log(`CFD conid for ${compania.iso}:`, cfdInfo.conid);
                  compania.cfdConid = cfdInfo.conid;
                  this._sseservice.apiPost('actualizarConidCfd', true, {
                    conid: compania.conid, conidcfd: cfdInfo.conid
                  }, 2).then((response) => {
                    console.log(`ConidCfd actualizado para ${compania.iso}:`, response);
                    resolve();
                  });
                } else {
                  resolve();
                }
              } else {
                console.log(`No CFD found for ${compania.iso}`);

                this._sseservice.apiPost('actualizarConidCfd', true, {
                  conid: compania.conid, conidcfd: -1
                }, 2).then((response) => {
                  console.log(`ConidCfd actualizado para ${compania.iso}:`, response);
                  resolve();
                });
                resolve();
              }
          //  }
          return;
        }),
        error: (error => {
          console.error(`Error fetching data for ${compania.iso}:`, error);
          resolve();
        })
      });
    });
  }
  private procesarCompaniaCFD(compania: any): Promise<void> {
    return new Promise((resolve) => {
      this.oauthService.apiGetIbrk(`/iserver/secdef/search?symbol=${compania.symbol}&name=true`).subscribe({
        next: (resp => {
          try {
            console.log(`getOptimalWallet resp for ${compania.iso}:`, resp);
            const cfdSection = resp.find((item: any) =>
              item.sections && item.sections.some((section: any) => section.secType === 'CFD')
            );

            if (cfdSection) {
              const cfdInfo = cfdSection.sections.find((section: any) => section.secType === 'CFD');
              if (cfdInfo && cfdInfo.conid) {
                console.log(`CFD conid for ${compania.iso}:`, cfdInfo.conid);
                compania.cfdConid = cfdInfo.conid;

                this._sseservice.apiPost('actualizarConidCfd', true, {
                  conid: compania.conid, conidcfd: cfdInfo.conid
                }, 2).then((response) => {
                  console.log(`ConidCfd actualizado para ${compania.iso}:`, response);
                  resolve();
                });
              } else {
                resolve();
              }
            } else {
              console.log(`No CFD found for ${compania.iso}`);

              this._sseservice.apiPost('actualizarConidCfd', true, {
                conid: compania.conid, conidcfd: -1
              }, 2).then((response) => {
                console.log(`ConidCfd actualizado para ${compania.iso}:`, response);
                resolve();
              });
              resolve();
            }
          } catch (error) {
            console.log('error de formato ');
          }
        }),
        error: (error => {
          console.error(`Error fetching data for ${compania.iso}:`, error);
          resolve();
        })
      });
    });
  }
  async buscarConidCfd() {
    console.log('buscar conid ' + this.companias2.length);
    for (const compania of this.companias2) {
      console.log(compania);
      if (compania.iso && compania.conid != null) {
        await this.procesarCompania(compania, true);
        await this.delay(1000); // Espera 1 segundo antes de la siguiente iteración
      }
    }

  }
  buscarMoneda() {
    if (this.currencySymbol) {
      // Aquí va la lógica para buscar la moneda
      console.log('Buscando moneda:', this.currencySymbol);
      // Implementa la lógica de búsqueda o llama a un servicio

      this.oauthService.apiGetIbrk(`/iserver/currency/pairs?currency=${this.currencySymbol}`).subscribe({
        next: (resp) => {
          console.log(resp);
          // Handle the response data here
        },
        error: (error) => {
          console.error('Error fetching market data:', error);
          // Handle any errors here
        }
      });
    }

  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log(filterValue);

    // Dividir el valor del filtro en criterios separados
    const filters = filterValue.split(' ');

    // Definir los criterios de filtro
    let isoFilter = '';
    let mercadoFilter = '';
    let tipoFilter = '';
    let descripcionFilter = '';
    let companiaFilter = '';
    let volumenFilter: { operator: string, value: number } | null = null;
    let cotizacionFilter: { operator: string, value: number } | null = null;

    filters.forEach(filter => {
      if (filter.startsWith('iso:')) {
        isoFilter = filter.substring(4).trim();
      } else if (filter.startsWith('mercado:')) {
        mercadoFilter = filter.substring(8).trim();
      } else if (filter.startsWith('tipo:')) {
        tipoFilter = filter.substring(5).trim();
      } else if (filter.startsWith('descripcion:')) {
        descripcionFilter = filter.substring(12).trim();
      } else if (filter.startsWith('compañia:')) {
        companiaFilter = filter.substring(9).trim();
      } else if (filter.startsWith('volumen>')) {
        const value = parseFloat(filter.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '>', value: value };
        }
      } else if (filter.startsWith('volumen<')) {
        const value = parseFloat(filter.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '<', value: value };
        }
      } else if (filter.startsWith('cotizacion>')) {
        const value = parseFloat(filter.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '>', value: value };
        }
      } else if (filter.startsWith('cotizacion<')) {
        const value = parseFloat(filter.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '<', value: value };
        }
      }
    });
    console.log("esto es iso:", isoFilter);
    console.log("esto es mercadoFilter:", mercadoFilter);
    console.log("esto es tipoFilter:", tipoFilter);
    console.log("esto es volumenFilter:", volumenFilter);
    console.log("esto es cotizacionFilter:", cotizacionFilter);

    return this.options.filter(
      (item: companiaLista) => {
        const mercadoMatch = mercadoFilter === '' || (item.mercado && item.mercado.toLowerCase().includes(mercadoFilter));
        const tipoMatch = tipoFilter === '' || (item.tipo && item.tipo.toLowerCase().includes(tipoFilter))
        const descripcionMatch = descripcionFilter === '' || (item.descripcion && item.descripcion.toLowerCase().includes(descripcionFilter))
        const isoMatch = companiaFilter === '' || (item.iso && item.iso.toLowerCase().includes(companiaFilter))
        let volumenMatch = true;
        if (volumenFilter) {
          switch (volumenFilter.operator) {
            case '>':
              volumenMatch = item.volumen > volumenFilter.value;
              break;
            case '<':
              volumenMatch = item.volumen < volumenFilter.value;
              break;
          }
        }
        let cotizacionMatch = true;
        if (cotizacionFilter) {
          switch (cotizacionFilter.operator) {
            case '>':
              cotizacionMatch = item.precioteorico > cotizacionFilter.value;
              break;
            case '<':
              cotizacionMatch = item.precioteorico < cotizacionFilter.value;
              break;
          }
        }
        return mercadoMatch && tipoMatch && descripcionMatch && isoMatch && volumenMatch && cotizacionMatch;
        // return mercadoMatch;
      }
    );

  }

  selected(event: MatAutocompleteSelectedEvent) {
    this.selectedIso = event.option.value;
    this.companiaselected = this.companias.find((compania: any) => compania.iso === this.selectedIso);
    console.log("compañia seleccionada o descripcion: ", this.companiaselected);
    console.log("cambio el select: ", this.selectedIso);
    this.cargarData(this.selectedIso);
  }

  cargarData(compania: any) {
    let url = 'v3/key-metrics-ttm/' + compania;
    let url2 = 'v3/ratios-ttm/' + compania;
    let url3 = 'v3/quote-short/' + compania;
    if (this.selectedIso) {
      this._sseservice.apiGetNew(url).subscribe({
        next: (data: any) => {
          this.keymetricsttm = data;
        }
      });
      this._sseservice.apiGetNew(url2).subscribe({
        next: (data: any) => {
          this.ratiosttm = data;
        }
      });
      this._sseservice.apiGetNew(url3).subscribe({
        next: (data: any) => {
          this.quoteshort = data;
        }
      });
    }
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    if (this.selectedTab === 3 && this.dataSourceUsuarios.data.length === 0) {
      this.cargarUsuarios();
    }
  }

  ngOnDestroy(): void {
    this.SubTema.unsubscribe();
    this.stopAuditProcess();

  }

  buscarMercado() {
    if (this.marketInput) {
      this.oauthService.apiGetIbrk(`/trsrv/all-conids?exchange=${this.marketInput}`).subscribe({
        next: (resp) => {
          console.log(resp);
          // Handle the response data here
        },
        error: (error) => {
          console.error('Error fetching market data:', error);
          // Handle any errors here
        }
      });
    }
  }


  buscarContrato() {
    if (this.contractSymbol) {
      this.oauthService.apiGetIbrk(`/iserver/secdef/search?symbol=${this.contractSymbol}`).subscribe({
        next: (resp => {
          console.log('Contract search response:', resp);
          // Handle the response data here
          // For example, you might want to display it in the template or process it further
        }),
        error: (error => {
          console.error('Error searching for contract:', error);
          // Handle the error here, maybe show a toastr message
        })
      });
    }
  }

  loadVariacionData() {
    const eventSource = new EventSource(global.url + 'revisionVariacionData');

    eventSource.addEventListener('variacion', (event: MessageEvent) => {
      const data: VariacionData = JSON.parse(event.data);
      this.dataSource.data = [...this.dataSource.data, data];
    });

    eventSource.onerror = (error) => {
      console.error('SSE Error:', error);
      eventSource.close();
    };
  }

  formatVariaciones(variacions: Variacion[]): string {
    return variacions.map(v =>
      `${new Date(v.fechaVariacion).toLocaleDateString()}: ${v.variacion.toFixed(2)}%`
    ).join(', ');
  }

  verGrafica(element: VariacionData, pagina: number) {
    // Implement your graph viewing logic
    if (pagina == 0) {
      console.log('Ver gráfica para:', element);
      const jsonData = {
        idNectum: element.idnectum.toString(),
        nombreComp: element.iso,
        idModelo: '0',
        isModelo: 'grafica'
      };
      this.queryParams = new URLSearchParams(jsonData).toString();
      window.open('/grafica-modelo/' + this.queryParams, '_blank');
    } else {
      window.open('https://site.financialmodelingprep.com/chart/' + element.iso, '_blank');
    }
  }

  borrarCompania(element: VariacionData) {
    // Implement your delete logic
  }
  startAuditProcess() {
    this.isLoading = true;
    this.dataSource.data = []; // Clear existing data

    this.eventSource = new EventSource(global.url + 'revisionVariacionData');

    this.eventSource.addEventListener('variacion', (event: MessageEvent) => {
      const data: VariacionData = JSON.parse(event.data);
      this.dataSource.data = [...this.dataSource.data, data];
    });

    this.eventSource.onerror = (error) => {
      console.error('SSE Error:', error);
      this.isLoading = false;
      this.eventSource?.close();
      this.eventSource = null;
    };
  }

  stopAuditProcess() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
    this.isLoading = false;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** Delete selected companies */
  deleteSelected() {
    const selectedCompanies = this.selection.selected;
    if (!selectedCompanies.length) return;

    // Format the data for the API call
    const payload = selectedCompanies.map(company => ({
      idNectum: company.idnectum
    }));

    this.isLoading = true;

    this._sseservice.apiPostNew('eliminarCompaniasPorIdnectum', payload, this.token).subscribe({
      next: (response) => {
        this.toastr.success(`${selectedCompanies.length} compañías eliminadas`, 'Éxito', { timeOut: 3000 });

        // Remove deleted companies from the table
        const remainingData = this.dataSource.data.filter(
          item => !selectedCompanies.some(selected => selected.idnectum === item.idnectum)
        );
        this.dataSource.data = remainingData;

        // Clear selection
        this.selection.clear();
      },
      error: (error) => {
        this.toastr.error('Error al eliminar compañías', 'Error', { timeOut: 3000 });
        console.error('Error deleting companies:', error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
  redownloadSelected() {
    const selectedCompanies = this.selection.selected;
    if (!selectedCompanies.length) return;

    this.isLoading = true;
    let index = 0;

    // Create an interval to process one company every second
    const downloadInterval = setInterval(() => {
      if (index >= selectedCompanies.length) {
        // Stop when all companies are processed
        clearInterval(downloadInterval);
        this.isLoading = false;
        this.toastr.success('Todas las descargas completadas', 'Éxito', { timeOut: 5000 });
        return;
      }

      const company = selectedCompanies[index];
      this._sseservice.apiGetNew(`descargarDatos?idmercado=0&idnectum=${company.idnectum}`).subscribe({
        next: (response) => {
          this.toastr.success(`Descarga completada: ${company.iso}`, 'Éxito', { timeOut: 3000 });
          console.log('Datos descargados:', response);
        },
        error: (error) => {
          this.toastr.error(`Error al descargar: ${company.iso}`, 'Error', { timeOut: 3000 });
          console.error('Error al descargar datos:', error);
        }
      });

      index++;
    }, 300); // Run every 1000ms (1 second)

    // Cleanup interval on component destroy
    this.ngOnDestroy = () => {
      if (downloadInterval) {
        clearInterval(downloadInterval);
      }
    };
  }
  buscarDuplicados() {
    this.isLoading = true;
    this.dataSource.data = []; // Limpiar datos existentes
    this._sseservice.apiGetSse2(`duplicadas`, 0).subscribe(
      {
        next: (resp: any) => {
          console.log('SSE connection established:', resp);
          this.isLoading = false;
        }
      }
    );

  }

  // Métodos para gestión de condiciones
  private initFormCondicion(): void {
    this.formCondicion = this.fb.group({
      indicadorHumano: ['', []],
      indicador: ['', [Validators.required]],
      detalle: ['', [Validators.required]],
      jsonData: ['', [Validators.required, this.jsonValidator]],
      verificado: [true],
      verificadoauto: [true],
      ratio: [false],
      explosionprecio: [false]
    });
  }

  // Validador personalizado para JSON
  private jsonValidator(control: AbstractControl): {[key: string]: any} | null {
    if (!control.value) return null;
    
    try {
      JSON.parse(control.value);
      return null;
    } catch (e) {
      return { 'invalidJson': true };
    }
  }

  ngAfterViewInit() {
    // Configurar el ordenamiento
    this.dataSourceCondicionesFiltrado.sort = this.sort;
    
    // Forzar detección de cambios después de que los datos se carguen
    this.cdRef.detectChanges();
  }

  cargarCondiciones() {
    this.isLoadingCondiciones = true;
    this._sseservice.apiGetNew('conditions/condiciones').subscribe({
        next: (data: any) => {
            console.log('Datos cargados:', data);
            if (Array.isArray(data) && data.length > 0) {
                this.dataSourceCondicionesFiltrado.data = data;
                console.log('Total registros:', data.length);
            } else {
                console.warn('No se recibieron datos o el array está vacío');
                this.dataSourceCondicionesFiltrado.data = [];
            }
            this.isLoadingCondiciones = false;
            this.cdRef.detectChanges();
        },
        error: (error) => {
            console.error('Error al cargar condiciones:', error);
            this.isLoadingCondiciones = false;
            this.cdRef.detectChanges();
        }
    });
  }

  // Método de filtro actualizado
  aplicarFiltro(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceCondicionesFiltrado.filter = filterValue.trim().toLowerCase();
    this.cdRef.detectChanges();
  }

  abrirDialogoNuevaCondicion() {
    this.esEdicion = false;
    this.initFormCondicion();
    
    this.dialog.open(this.dialogoCondicion, {
      width: '800px',
      hasBackdrop: true,
      panelClass: 'condition-dialog', // Añade esta clase personalizada
      autoFocus: false // Evita el enfoque automático que puede cerrar el menú de menciones
    });
  }

  editarCondicion(condicion: Condicion): void {
    this.esEdicion = true;
    this.condicionActual = condicion;
    
    this.formCondicion.patchValue({
      indicador: condicion.indicador,
      detalle: condicion.detalle,
      jsonData: condicion.jsonData, // Agregar esta línea
      verificado: condicion.verificado,
      verificadoauto: condicion.verificadoauto,
      ratio: condicion.ratio,
      explosionprecio: condicion.explosionprecio
    });
    
    this.dialog.open(this.dialogoCondicion, {
      width: '600px',
      disableClose: true
    });
  }

  guardarCondicion(): void {
      
    this.isLoadingCondiciones = true;
    const formValue = this.formCondicion.value;
    
    const condicionData: Condicion = {
      idindicador: 0,
      indicador: formValue.indicador.replace(/#/g, ''),
      detalle: formValue.detalle,
      jsonData: formValue.jsonData,
      verificado: formValue.verificado,
      verificadoauto: formValue.verificadoauto,
      ratio: formValue.ratio,
      explosionprecio: formValue.explosionprecio
    };

    if (this.esEdicion && this.condicionActual) {
      // Actualizar condición existente
      this.http.put<Condicion>(`${global.url}conditions/condiciones/${this.condicionActual.idindicador}`, condicionData)
        .subscribe({
          next: (data) => {
       
            this.dialog.closeAll();
            this.toastr.success('Condición actualizada exitosamente', 'OK', { timeOut: 3000, positionClass: 'toast-top-center' });
            this.isLoadingCondiciones = false;
          },
          error: (error) => {
            console.error('Error al actualizar condición:', error);
            this.isLoadingCondiciones = false;
            this.toastr.error('Error al actualizar condición', 'Error', { timeOut: 3000, positionClass: 'toast-top-center' });
          }
        });
    } else {
      // Crear nueva condición
      this.http.post<Condicion>(`${global.url}conditions/condiciones`, condicionData)
        .subscribe({
          next: (data) => {
        
            this.dialog.closeAll();
            this.toastr.success('Condición creada exitosamente', 'OK', { timeOut: 3000, positionClass: 'toast-top-center' });
            this.isLoadingCondiciones = false;
          },
          error: (error) => {
            console.error('Error al crear condición:', error);
            this.isLoadingCondiciones = false;
            this.toastr.error('Error al crear condición', 'Error', { timeOut: 3000, positionClass: 'toast-top-center' });
          }
        });
    }
  }

  eliminarCondicion(id: number): void {
    if (confirm('¿Está seguro de que desea eliminar esta condición?')) {
      this.isLoadingCondiciones = true;
      
      this.http.delete(`${global.url}conditions/condiciones/${id}`)
        .subscribe({
          next: () => {
            this.toastr.success('Condición eliminada exitosamente', 'OK', { timeOut: 3000, positionClass: 'toast-top-center' });
          },
          error: (error) => {
            console.error('Error al eliminar condición:', error);
            this.isLoadingCondiciones = false;
            this.toastr.error('Error al eliminar condición', 'Error', { timeOut: 3000, positionClass: 'toast-top-center' });
          }
        });
    }
  }

  // Agregar el método para actualizar estado individual
  actualizarEstado(condicion: Condicion, campo: string, valor: boolean): void {
    this.isLoadingCondiciones = true;
    
    const condicionActualizada = { ...condicion };
    (condicionActualizada as any)[campo] = valor;
    
    this.http.put<Condicion>(`${global.url}conditions/condiciones/${condicion.idindicador}`, condicionActualizada)
      .subscribe({
        next: (data) => {
          // Actualizar en ambos datasources
          const updateInDataSource = (dataSource: MatTableDataSource<Condicion>) => {
            const index = dataSource.data.findIndex(c => c.idindicador === condicion.idindicador);
            if (index !== -1) {
              const newData = [...dataSource.data];
              newData[index] = data;
              dataSource.data = newData;
            }
          };
          
          //updateInDataSource(this.dataSourceCondiciones);
          updateInDataSource(this.dataSourceCondicionesFiltrado);
          
          this.isLoadingCondiciones = false;
          this.toastr.success(`${campo} actualizado exitosamente`, 'OK', { timeOut: 2000, positionClass: 'toast-top-center' });
        },
        error: (error) => {
          console.error('Error al actualizar:', error);
          this.isLoadingCondiciones = false;
          this.toastr.error('Error al actualizar el estado', 'Error', { timeOut: 3000, positionClass: 'toast-top-center' });
          // Revertir el cambio en caso de error
        }
      });
  }


  interpretacionCondicionConIA(): void {
    const indicadorValue = this.formCondicion.get('indicadorHumano')?.value;
    
    if (!indicadorValue || indicadorValue.trim() === '') {
      this.toastr.error('Por favor ingrese un indicador antes de validar con IA');
      return;
    }

    // Mostrar loading state
    this.isLoadingCondiciones = true;
    
    this._sseservice.apiPostNew('conditions/interpretar_conditions', JSON.stringify({ input: indicadorValue, source: 'admin' }), this.token).subscribe({
      next: (response:any) => {
        this.isLoadingCondiciones = false;
        
          this.formCondicion.get('indicador')?.setValue(response.response);
          // Mostrar mensaje de éxito
          this.toastr.success('Condición validada exitosamente con IA');
        
      }
    });
  }

validarCondicionConIA(): void {
    const indicadorValue = this.formCondicion.get('indicador')?.value;
    
    if (!indicadorValue || indicadorValue.trim() === '') {
      this.toastr.error('Por favor ingrese un indicador antes de validar con IA');
      return;
    }

    // Mostrar loading state
    this.isLoadingCondiciones = true;
    
 // Normalizar la entrada reemplazando diferentes formas de 'and'
    let normalizedInput = indicadorValue.trim().replaceAll('#','');
    if (normalizedInput.includes(' y '))
        normalizedInput = normalizedInput.replaceAll(' y ', ' AND ');
    if (normalizedInput.includes(' && '))
        normalizedInput = normalizedInput.replaceAll(' && ', ' AND ');
    if (normalizedInput.includes(' & '))
        normalizedInput = normalizedInput.replaceAll(' & ', ' AND ');
    if (normalizedInput.includes(' and '))
        normalizedInput = normalizedInput.replaceAll(' and ', ' AND ');
    
    // Dividir por 'and' si existe
    const conditions = normalizedInput.includes(' AND ') ? 
                      normalizedInput.split(' AND ') : 
                      [normalizedInput];

    console.log('Condiciones a procesar:', conditions);
    
    // Array para almacenar resultados de cada condición
    const processedConditions: any[] = [];
    let processedCount = 0;
let condicionjson = '';
    conditions.forEach((condition:string, index: number) => {

    // Reemplazar la condición según sea necesario
    let indicaorestemp: string[] = [];
    let condicionreemplazada = this.replaceWithIndicators(condition.trim(), indicaorestemp)
   

    this._sseservice.apiPostNew('conditions/get_conditions', JSON.stringify({ input: condicionreemplazada }), this.token).subscribe({
      next: (response:any) => {
        this.isLoadingCondiciones = false;
        
          console.log('Respuesta del endpoint:', JSON.stringify(response));
          
          let finalSentence = this.restoreWithOriginalWords(JSON.stringify(response), indicaorestemp);
          let interpretacionData = JSON.parse(finalSentence);
          let condicionuno = interpretacionData.output[0];
          console.log('Condición interpretada:', condicionuno);
          if(processedCount === 0) {
            condicionjson = JSON.stringify(condicionuno); // condicionuno to string 

          }else {
            condicionjson += ',' + JSON.stringify(condicionuno);
          }
          this.formCondicion.get('jsonData')?.setValue(condicionjson);
          processedCount++;
          // Mostrar mensaje de éxito
          this.toastr.success('Condición validada exitosamente con IA');
      }
    });


    });
  }

  /**
   * Track by function for virtual scrolling optimization
   */
  trackByFn(index: number, item: Condicion): number {
      return item.idindicador || index;
  }

  descargarSpecificacion(): void {
    if (!this.metaapiAccountId || !this.metaapiSymbol) return;
    this.specLoading = true;
    this.specResult = null;
    this.metaApiService.getSymbolSpecification(this.metaapiAccountId, this.metaapiSymbol).subscribe({
      next: (spec: any) => {
        this.specLoading = false;
        this.specResult = spec;
        if (spec) {
          const licencia = this._cookieService.get('auth_token');
          this._sseservice.apiPostNew('metaapi/specificationes', { ...spec, tipoBroker: this.specTipoBroker }, licencia).subscribe({
            next: (res: any) => this.toastr.success('Especificación registrada correctamente'),
            error: () => this.toastr.error('Error al registrar especificación')
          });
        } else {
          this.toastr.error('No se obtuvo especificación para ' + this.metaapiSymbol);
        }
        this.cdRef.markForCheck();
      },
      error: () => {
        this.specLoading = false;
        this.toastr.error('Error al obtener especificación de MetaAPI');
        this.cdRef.markForCheck();
      }
    });
  }

  async descargarSpecificacionesPorLista(): Promise<void> {
    if (!this.metaapiAccountId || !this.specListMercado) return;
    const licencia = this._cookieService.get('auth_token');
    this.specListLoading = true;
    this.specListProgress = 0;
    this.specListTotal = 0;
    this.specListErrors = [];
    this.cdRef.markForCheck();

    this._sseservice.apiPostNew('listadecompaniaspormercado', { idmercado: this.specListMercado }, this.token).subscribe({
      next: async (companias: any[]) => {
        if (!companias || !companias.length) {
          this.toastr.error('No se encontraron companías para el mercado seleccionado.');
          this.specListLoading = false;
          this.cdRef.markForCheck();
          return;
        }
        this.specListTotal = companias.length;
        this.cdRef.markForCheck();

        for (const compania of companias) {
          const iso: string = compania.iso || compania.symbol || '';
          if (!iso) { this.specListProgress++; continue; }
          await new Promise<void>(resolve => {
            this.metaApiService.getSymbolSpecification(this.metaapiAccountId, iso).subscribe({
              next: (spec: any) => {
                if (spec) {
                  this._sseservice.apiPostNew('metaapi/specificationes', { ...spec, tipoBroker: this.specTipoBroker }, licencia).subscribe({
                    next: () => {},
                    error: () => this.specListErrors.push(iso + ': error al guardar')
                  });
                } else {
                  this.specListErrors.push(iso + ': sin datos');
                }
                resolve();
              },
              error: () => {
                this.specListErrors.push(iso + ': error MetaAPI');
                resolve();
              }
            });
          });
          this.specListProgress++;
          this.cdRef.markForCheck();
          await this.delay(600);
        }

        this.specListLoading = false;
        const ok = this.specListProgress - this.specListErrors.length;
        this.toastr.success(`Descarga completada: ${ok}/${this.specListTotal} especificaciones registradas.`);
        if (this.specListErrors.length) {
          this.toastr.error(`${this.specListErrors.length} errores. Ver consola.`);
          console.warn('[MetaAPI lista] Errores:', this.specListErrors);
        }
        this.cdRef.markForCheck();
      },
      error: () => {
        this.specListLoading = false;
        this.toastr.error('Error al cargar la lista de compañías.');
        this.cdRef.markForCheck();
      }
    });
  }
}
